<template>
  <div class="loadingLayoutContainer">
    <c-loading-screen></c-loading-screen>
  </div>
</template>

<script>
export default {}
</script>
